import React, { useEffect, useState } from "react";
import styles from "./XpStatus.module.css";

const XpStatus = ({ xp, level, xpProgress, className }) => {
    const [displayLevel, setDisplayLevel] = useState(level);
    const [animatedProgress, setAnimatedProgress] = useState(0);

    // SVG Constants
    const size = 50; // Total width/height
    const strokeWidth = 4;
    const center = size / 2;
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;

    useEffect(() => {
        // Simple delay to trigger the CSS transition on mount
        const timer = setTimeout(() => {
            setAnimatedProgress(xpProgress);
        }, 100);
        
        if (level > displayLevel) {
            setDisplayLevel(level);
        }
        
        return () => clearTimeout(timer);
    }, [level, xpProgress, displayLevel]);

    // Calculate the offset: 0% = circumference, 100% = 0
    const offset = circumference - (animatedProgress / 100) * circumference;

    return (
        <div className={`${styles.xpContainer} ${className}`}>
            <div className={styles.ringWrapper}>
                <svg width={size} height={size} className={styles.svg}>
                    {/* Background Track */}
                    <circle
                        className={styles.track}
                        cx={center}
                        cy={center}
                        r={radius}
                        strokeWidth={strokeWidth}
                    />
                    {/* Progress Fill */}
                    <circle
                        className={styles.fill}
                        cx={center}
                        cy={center}
                        r={radius}
                        strokeWidth={strokeWidth}
                        style={{
                            strokeDasharray: circumference,
                            strokeDashoffset: offset,
                        }}
                    />
                </svg>
                {/* Level Number in the middle */}
                <div className={styles.levelCenter}>
                    <span className={styles.levelValue}>{displayLevel}</span>
                </div>
            </div>
            
            {/* Desktop Only Text - hidden on mobile via CSS */}
            <div className={styles.desktopInfo}>
                <span className={styles.xpText}>{xp.toLocaleString()} XP</span>
            </div>
        </div>
    );
};

export default XpStatus;